angular.module("ainapp")
    .controller("approvalDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Approval Dashboard";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }


            $scope.Init = function () {

                $scope.ViewVal = 0;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.dashcountsPurchase = [];
                MainService.GetPendApprovalDocsCountPurchase().then(function (response) {
                    $scope.dashcountsPurchase = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.dashcountsSales = [];
                MainService.GetPendApprovalDocsCountSales().then(function (response) {
                    $scope.dashcountsSales = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.dashcountsPayments = [];
                MainService.GetPendApprovalDocsCountPayments().then(function (response) {
                    $scope.dashcountsPayments = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.dashcountsReceipts = [];
                MainService.GetPendApprovalDocsCountReceipts().then(function (response) {
                    $scope.dashcountsReceipts = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.dashcountsBasics = [];
                MainService.GetPendApprovalDocsCountBasics().then(function (response) {
                    $scope.dashcountsBasics = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.dashcountsStock = [];
                MainService.GetPendApprovalDocsCountStock().then(function (response) {
                    $scope.dashcountsStock = response.data;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();

                        }])
